import Backbone from 'backbone'
import _ from 'lodash'
import template from './simple-dataset-selector.hbs'
import TreeActions from '../tree-actions'
import i18n from '../i18n'
import SimpleDatasetGardener from './simple-dataset-gardener'

/**
 * Meant to be used in a bootslide menu. This displays a list of datasets that
 * can be selected. Rather than providing an org/dataset tree, this selector
 * accepts a list of datasets to display. The order they are displayed match how
 * they are passed in
 */
const SimpleDatasetSelector = Backbone.View.extend({
	className: 'dataset-field-selector',

	/** @type {Dataset[]} */
	datasets: null,

	/**
	 * @param {Dataset[]} opts.datasets the datasets to show in the list
	 * @param {Number} opts.initialDatasetId if provided, describes the root or
	 * main dataset meaning all other datasets are linked to it.
	 */
	initialize: function(opts = {}) {
		this.datasets = opts.datasets
		this.initialDatasetId = opts.initialDatasetId
	},

	render: function () {
		this.$el.html(template())

		this.gardener = new SimpleDatasetGardener({
			datasets: this.datasets,
			initialDatasetId: this.initialDatasetId
		})

		this.$('.gardener').replaceWith(this.gardener.el)
		this.gardener.render()
		this.gardener.show().startStream()

		this._setupTreeAction()
		return this
	},

	_setupTreeAction: function() {
		this.treeActions && this.treeActions.remove()

		this.treeActions = new TreeActions({
			el: this.gardener.tree.el.node(),
			tree: this.gardener.tree,
			buttonContent: i18n.get('common.select'),
			nodesReselectable: true
		}).render()
		this.treeActions.on('selected', () => this.select())
	},

	select: function () {
		var selected = this.gardener.tree.selected()

		this.trigger('select', { dataset: selected })
	},

	remove: function() {
		Backbone.View.prototype.remove.apply(this, arguments)
		_.invokeMap([this.gardener], 'remove')
	}
})

export default SimpleDatasetSelector
SimpleDatasetSelector.__filename__ = 'components/bootslide/simple-dataset-selector.js'
